/**
 * O portal de uma ala inteira no painel — o `academy_portal_card.dart` e o
 * `play_zone_portal_card.dart`, que são o mesmo cartão com outro ícone, outro
 * título e outro destino.
 *
 * São a porta de entrada da Academia e da Zona de Jogos. Cada ala tem quatro
 * telas que se chamam entre si, mas nenhuma delas se alcança de fora: `/academy`
 * e `/play-zone` só aparecem aqui, como no Flutter, onde estes dois cartões
 * moram no painel e em mais lugar nenhum.
 *
 * Um só componente para os dois porque em Flutter eles já são o mesmo arquivo
 * copiado: mesma altura de 220, mesmo halo rosa no canto, mesmo emblema que
 * respira, mesmo botão de degradê. O que muda cabe em quatro props.
 */

import { Link } from 'react-router-dom';
import type { NomeDoIcone } from '@nosso-sempre/shared';
import { Icone } from './Icone';
import './cartaoPortal.css';

interface Props {
  icone: NomeDoIcone;
  titulo: string;
  /** O texto do botão. Em maiúsculas nos dois, como lá. */
  botao: string;
  para: string;
  /** O `Semantics.label` do botão de lá. */
  rotulo: string;
}

export function CartaoPortal({ icone, titulo, botao, para, rotulo }: Props) {
  return (
    <div className="portal">
      <span className="portal-halo" aria-hidden="true" />
      <span className="portal-emblema" aria-hidden="true">
        <Icone nome={icone} tamanho={50} />
      </span>
      <p className="portal-titulo">{titulo}</p>
      <Link className="portal-botao" to={para} aria-label={rotulo}>
        {botao}
      </Link>
    </div>
  );
}
